const validate = process.env.REACT_APP_ENV || 'local';

let Env;

if (validate === 'production') {
  Env = require('./env.production.js');
} else {
  Env = require('./env.local.js');
}

export default Env.default
